import "./index.css";
// src/SignInBanner/SignInBanner.tsx
import Box from "@cloudscape-design/components/box";
import Button from "@cloudscape-design/components/button";
import SpaceBetween from "@cloudscape-design/components/space-between";
import { useAppTranslation } from "@amzn/awsmp-max-translations";

// src/SignInBanner/SignInBanner.module.scss
var SignInBanner_module_default = {
  banner: "SignInBanner_module_banner"
};

// src/SignInBanner/SignInBanner.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var SignInBanner = ({ visible, onSignIn, onDismiss }) => {
  const { t } = useAppTranslation();
  if (!visible) {
    return null;
  }
  return /* @__PURE__ */ jsxs("div", { className: SignInBanner_module_default.banner, "data-testid": "sign-in-banner", children: [
    /* @__PURE__ */ jsx(Box, { variant: "span", children: t("signInBannerMessage") }),
    /* @__PURE__ */ jsxs(SpaceBetween, { direction: "horizontal", size: "xs", children: [
      /* @__PURE__ */ jsx(Button, { variant: "primary", onClick: onSignIn, "data-testid": "sign-in-banner-button", children: t("signInToAws") }),
      /* @__PURE__ */ jsx(Button, { variant: "icon", iconName: "close", onClick: onDismiss, ariaLabel: t("close"), "data-testid": "sign-in-banner-dismiss" })
    ] })
  ] });
};
export {
  SignInBanner
};
//# sourceMappingURL=index.js.map
